(function () {
  var STYLE_KEY = 'withdrawal-form-full-width';

  function getThemeFonts() {
    var root = getComputedStyle(document.documentElement);

    return {
      body: root.getPropertyValue('--font-body-family').trim(),
      heading: root.getPropertyValue('--font-heading-family').trim(),
      bodyWeight: root.getPropertyValue('--font-body-weight').trim() || '400',
      headingWeight: root.getPropertyValue('--font-heading-weight').trim() || '600',
      bodyStyle: root.getPropertyValue('--font-body-style').trim() || 'normal',
      button: root.getPropertyValue('--font-button-family').trim()
    };
  }

  function buildStyleRules() {
    var fonts = getThemeFonts();
    var root = getComputedStyle(document.documentElement);
    var bodyScale = parseFloat(root.getPropertyValue('--font-body-scale').trim()) || 1;
    var radioChoiceSize = (bodyScale * 1.8).toFixed(2) + 'rem';
    var bodyFont = fonts.body || 'inherit';
    var headingFont = fonts.heading || bodyFont;
    var buttonFont = fonts.button || bodyFont;

    return [
      ':host {',
      '  max-width: 100% !important;',
      '  width: 100% !important;',
      '  box-sizing: border-box !important;',
      '  --forms-body-font: ' + bodyFont + ';',
      '  --forms-heading-font: ' + headingFont + ' ' + fonts.headingWeight + ' 1.6rem ' + bodyFont + ';',
      '}',
      'form,',
      '[class*="formContainer"],',
      '[class*="_formContainer"],',
      '[class*="inline"],',
      '[class*="_inline"],',
      '[class*="_noImage"] {',
      '  max-width: 100% !important;',
      '  width: 100% !important;',
      '  box-sizing: border-box !important;',
      '  padding-inline-end: 0.6rem !important;',
      '}',
      'h1, h2, h3, h4, [class*="heading"], [class*="Heading"] {',
      '  font-family: ' + headingFont + ' !important;',
      '  font-style: normal !important;',
      '  font-weight: ' + fonts.headingWeight + ' !important;',
      '}',
      'label, input, textarea, select, button, p, span, legend, option {',
      '  font-family: ' + bodyFont + ' !important;',
      '  font-style: ' + fonts.bodyStyle + ' !important;',
      '  font-weight: ' + fonts.bodyWeight + ' !important;',
      '}',
      'button, [type="submit"] {',
      '  font-family: ' + buttonFont + ' !important;',
      '}',
      'label:has(input[type="radio"]),',
      'input[type="radio"] + label,',
      'input[type="radio"] + span,',
      '[class*="radioOption"],',
      '[class*="RadioOption"],',
      '[class*="choiceItem"],',
      '[class*="ChoiceItem"],',
      '[class*="choiceLabel"],',
      '[class*="ChoiceLabel"],',
      '[class*="radio"] label,',
      '[class*="Radio"] label {',
      '  font-size: ' + radioChoiceSize + ' !important;',
      '  line-height: 1.45 !important;',
      '}'
    ].join('\n');
  }

  function setFormStylesMap() {
    window.formStyles = window.formStyles || new Map();
    window.formStyles.set(STYLE_KEY, buildStyleRules());
  }

  function injectShadowStyles(embed) {
    var root = embed.shadowRoot;
    if (!root) return;

    var style = root.querySelector('[data-withdrawal-form-width]');
    var rules = buildStyleRules();

    if (style) {
      style.textContent = rules;
      return;
    }

    style = document.createElement('style');
    style.setAttribute('data-withdrawal-form-width', '');
    style.textContent = rules;
    root.appendChild(style);
  }

  function applyWithdrawalFormStyles() {
    setFormStylesMap();
    document.querySelectorAll('form-embed, shopify-forms-embed').forEach(injectShadowStyles);
  }

  setFormStylesMap();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyWithdrawalFormStyles);
  } else {
    applyWithdrawalFormStyles();
  }

  document.addEventListener('shopify:section:load', applyWithdrawalFormStyles);

  new MutationObserver(applyWithdrawalFormStyles).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
